<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "LanguageComponent",
};
</script>

<style scoped>

</style>
